import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Box, Tooltip } from '@components/common';
import SvgIcon from '@components/SvgIcon';

const FullItemIcon = styled(SvgIcon)`
  margin-top: 4px;
`;

const IconWithTooltip = styled(Box)`
  width: 16px;
  height: 16px;
`;

const EXTRA_ITEM_POSITION_TOP = {
  pad: [50, 50, 28, 28, 50],
  desktop: [68, 68, 42, 42, 16]
};

const EXTRA_ITEM_POSITION_LEFT = {
  pad: [52, 32, 52, 32, 2],
  desktop: [68, 42, 68, 42, 6]
};

function CalendarViewFullItem(props) {
  const {
    iconFill,
    serviceTypeIcon,
    timeframeIcon,
    timeframeTitle,
    fullTitle,
    iconProps,
    disabled,
    selected,
    onItemClick,
    extraItems,
    extraItemsPositionTop,
    extraItemsPositionLeft,
    ...restProps
  } = props;

  const positionTop = extraItemsPositionTop
    ? extraItemsPositionTop
    : EXTRA_ITEM_POSITION_TOP;
  const positionLeft = extraItemsPositionLeft
    ? extraItemsPositionLeft
    : EXTRA_ITEM_POSITION_LEFT;

  return (
    <Box
      display="flex"
      alignSelf="stretch"
      flexDirection="column"
      alignItems={['center', 'flex-start']}
      justifyContent={['center', 'flex-start']}
      position="relative"
      flex={1}
      width={[52, 72, 80]}
      onClick={() => {
        if (onItemClick) {
          onItemClick();
        }
      }}
    >
      {fullTitle ? (
        <Tooltip
          animation="scale"
          delay={[300, 0]}
          duration={300}
          content={fullTitle}
          theme="light-border"
          placement="bottom"
        >
          <span>
            <FullItemIcon
              name={serviceTypeIcon}
              disabled={disabled && !selected}
              fill={iconFill ? iconFill : undefined}
              {...iconProps}
            />
          </span>
        </Tooltip>
      ) : (
        <FullItemIcon
          name={serviceTypeIcon}
          disabled={disabled && !selected}
          fill={iconFill ? iconFill : undefined}
          {...iconProps}
        />
      )}

      {timeframeIcon && (
        <Tooltip
          animation="scale"
          delay={[300, 0]}
          duration={300}
          content={timeframeTitle}
          theme="light-border"
          placement="bottom"
        >
          <span>
            <FullItemIcon
              display={['none', 'block']}
              name={timeframeIcon}
              disabled={disabled && !selected}
              color={iconFill ? iconFill : 'gold'}
              {...iconProps}
            />
          </span>
        </Tooltip>
      )}

      {extraItems &&
        extraItems.map((addon, index) => {
          const { name, icon: addonIcon, title } = addon;
          return (
            <IconWithTooltip
              style={{
                position: 'absolute',
                margin: 0
              }}
              left={[
                0,
                positionLeft['pad'][index],
                positionLeft['desktop'][index]
              ]}
              top={[
                0,
                positionTop['pad'][index],
                positionTop['desktop'][index]
              ]}
              key={name}
            >
              <Tooltip
                key={name}
                content={title}
                theme="light-border"
                arrow={true}
                duration={300}
                animation="scale"
                delay={[300, 0]}
              >
                <span>
                  <FullItemIcon
                    name={addonIcon}
                    color={iconFill ? iconFill : 'gold'}
                    disabled={disabled}
                    {...iconProps}
                  />
                </span>
              </Tooltip>
            </IconWithTooltip>
          );
        })}
    </Box>
  );
}

CalendarViewFullItem.propTypes = {
  iconFill: PropTypes.string,
  serviceTypeIcon: PropTypes.string.isRequired,
  timeframeIcon: PropTypes.string,
  timeframeTitle: PropTypes.string,
  fullTitle: PropTypes.string,
  iconProps: PropTypes.object,
  disabled: PropTypes.bool,
  selected: PropTypes.bool,
  onItemClick: PropTypes.func,
  extraItems: PropTypes.array,
  extraItemsPositionTop: PropTypes.object,
  extraItemsPositionLeft: PropTypes.object
};

export default CalendarViewFullItem;
